import React, { FC } from "react";
import { Field } from "react-final-form";
import { makeStyles } from "@material-ui/core";
import InputLabel from "@material-ui/core/InputLabel";
import WeduRadio from "../../../../../components/WeduRadio/WeduRadio";
import FieldsGroupLabel from "../common/FieldsGroupLabel";
import { COURSE_TYPES_MAP } from "../../../constants";
import { CourseType, ICourseComponentProps } from "../../../types";

const useStyles = makeStyles(() => ({
  container: {
    width: 199,
  },
  radioGroup: {
    display: "flex",
    justifyContent: "flex-start",
    "& > label + label": {
      marginLeft: 40,
    },
  },
}));

const CourseTypeInput: FC<ICourseComponentProps> = ({
  fieldsGroupName,
  errors,
}) => {
  const classes = useStyles();

  return (
    <div>
      <FieldsGroupLabel
        isRequired
        label="Course Type"
        hasError={!!errors?.courseType}
        infoText="You need to choose either of them. If you have both you need to create each separately."
        className="fields-group-label"
      />
      <div className={classes.container}>
        <div className={classes.radioGroup}>
          <Field
            name={`${fieldsGroupName}.courseType`}
            component={WeduRadio}
            type="radio"
            value={CourseType.ON_CAMPUS.toString()}
            label={COURSE_TYPES_MAP[CourseType.ON_CAMPUS]}
          />
          <Field
            name={`${fieldsGroupName}.courseType`}
            component={WeduRadio}
            type="radio"
            value={CourseType.ONLINE.toString()}
            label={COURSE_TYPES_MAP[CourseType.ONLINE]}
          />
        </div>
        {!!errors?.courseType && (
          <InputLabel className="field-error-text">
            {errors.courseType}
          </InputLabel>
        )}
      </div>
    </div>
  );
};

export default React.memo(CourseTypeInput);
